import { render, staticRenderFns } from "./LocationTableTotal.vue?vue&type=template&id=4866cfc2"
import script from "./LocationTableTotal.vue?vue&type=script&lang=js"
export * from "./LocationTableTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports